export default __webpack_public_path__ + "static/media/processing_green.1d3c363a.svg";